"use client";

import { useMediaContext } from "@/features/media/useMediaContext";
import { useProjectConfigs } from "@/features/project/ProjectContext";
import type { ItemProperties } from "@/types";
import { poiGalleries } from "../../poiGalleries";
import { POIGalleryButton } from "./POIGalleryButton";
import { cn } from "@/lib/cn";

/** The row of gallery cards under a POI's details, one per media type it has. */
export function POIGalleries({
  properties,
  className,
  onlyGroups,
}: {
  properties: ItemProperties;
  className?: string;
  onlyGroups?: string[];
}) {
  const configs = useProjectConfigs();
  const media = useMediaContext();

  let groups = poiGalleries(properties, configs, media);
  if (groups.length === 0) return null;

  if (onlyGroups?.length) {
    groups = groups.filter((group) => onlyGroups.includes(group.type));
  }

  return (
    <div
      className={cn(
        "gallery grid grid-cols-2 gap-5 bg-white dark:bg-dark-color",
        className
      )}
    >
      {groups.map((group) => (
        <POIGalleryButton key={group.type} group={group} />
      ))}
    </div>
  );
}
